import {ReactNode} from 'react';
import {Alert, Device, ServerAlert} from '../../Types/types';

export const parseHeaders = (headers: string) => {
	// old clojure format
	if (headers.startsWith('{:headers')) {
		let addExtraHeaderField = false;
		const cleanString = headers.replace(/[{}]/g, '').replace(':headers ', '').split(', '); // Remove curly braces

		if (cleanString.length < 4 && cleanString[0] !== '') {
			addExtraHeaderField = true;
		}

		const res: {key: string; value: string}[] = [];
		cleanString.forEach((header) => {
			const [key, value] = header.split(' ');

			if (key && value) {
				res.push({key: key.slice(1, -1), value: value.slice(1, -1)});
			}
		});
		if (addExtraHeaderField) res.push({key: '', value: ''});
		return res;
	} else {
		const jsonHeaders = JSON.parse(headers);
		if (jsonHeaders.length === 0 || (jsonHeaders.length < 4 && jsonHeaders[0].key !== '')) {
			jsonHeaders.push({key: '', value: ''});
		}
		return jsonHeaders;
	}
};

export function validateCondition(value: string): string | true {
	if (value === '') {
		return 'Please enter a value for the calibration';
	}

	if (!value.includes('$')) {
		return 'The calibration value must include a $ symbol';
	}

	const mathExpression = value.replaceAll('$', '1');
	try {
		/*jslint evil: true */
		const result = Function("'use strict'; return (" + mathExpression + ')')();
		if (result === undefined || typeof result !== 'boolean') {
			return 'The Condition is not returning a boolean value';
		}
	} catch (e) {
		return 'The Condition is not returning a boolean value';
	}

	return true;
}

// id is used to fetch the data from the object that we use
// title is the title of the column/the displayed text
// width is the width of the column (not used)
// onClick is the function that is called when the column is clicked
// priority is the priority of the column, for mobile table, depending on screensize the amount of priorities are displayed
const arrayJoinRenderer = (value: Array<ReactNode> | ReactNode): ReactNode => {
	if (Array.isArray(value)) {
		return value.join(', ');
	}
	return value;
};

export const columns = [
	{
		id: 'name',
		title: 'Name',
		width: 250,
		priority: 1,
		isKey: true,
	},

	{
		id: 'sensorType',
		title: 'Type',
		width: 350,
		priority: 3,
		renderer: arrayJoinRenderer,
	},
	{
		id: 'deviceIds',
		title: 'Device IDs',
		width: 350,
		priority: 2,
		renderer: arrayJoinRenderer,
	},
	{
		id: 'action',
		title: 'Action',
		width: 150,
		//onClick: () => alert("Should send an email!"),
		priority: 4,
	},
	{
		id: 'condition',
		title: 'Condition',
		width: 150,
		priority: 2,
	},
];

function transformer(serverAlert: ServerAlert, devices: Device[]): Alert {
	const deviceIdSet = new Set<string>();
	const sensorTypeSet = new Set<string>();
	//get the friendly name of the device
	serverAlert.deviceSensors.forEach((deviceSensor) => {
		const device = devices.find((device) => device.id === deviceSensor.deviceId);
		if (device) {
			if (device.deviceName) {
				deviceIdSet.add(device.deviceName);
			} else {
				deviceIdSet.add(deviceSensor.deviceId);
			}
		}
		sensorTypeSet.add(deviceSensor.sensor);
	});
	const alert: Alert = {
		id: serverAlert.id,
		name: serverAlert.name,
		deviceIds: Array.from(deviceIdSet),
		sensorType: Array.from(sensorTypeSet),
		action: serverAlert.action,
		recipient: serverAlert.recipient,
		condition: serverAlert.condition,
		message: serverAlert.message,
		subject: serverAlert.subject,
		triggerInterval: serverAlert.triggerInterval,
		mqttCredentials: serverAlert.mqttCredentials !== null ? JSON.parse(serverAlert.mqttCredentials) : {port: 0, usernam: '', password: ''},
		customheaders: serverAlert.header !== null ? parseHeaders(serverAlert.header) : [],
	};
	return alert;
}

export function alertToDisplay(serverAlerts: ServerAlert[], devices: Device[]): Alert[];
export function alertToDisplay(serverAlerts: ServerAlert, devices: Device[]): Alert;

export function alertToDisplay(serverAlerts: ServerAlert[] | ServerAlert, devices: Device[]): Alert[] | Alert {
	if (Array.isArray(serverAlerts)) {
		return serverAlerts.map((serverAlert) => transformer(serverAlert, devices));
	} else {
		return transformer(serverAlerts, devices);
	}
}
